import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface LayoutHeaderToolbarAction {
    id: string;
    icon: string;
    tooltip: string;
    ariaLabel?: string;
    color?: 'primary';
    disabled?: boolean;
    handler: () => void;
}

export interface LayoutHeaderContextSubMenuItem {
    id: string;
    label: string;
    checked?: boolean;
    chipClass?: string;
    handler: () => void;
}

export interface LayoutHeaderContextMenuItem {
    id: string;
    label: string;
    icon: string;
    disabled?: boolean;
    active?: boolean;
    color?: 'primary' | 'accent' | 'warn';
    handler?: () => void;
    submenu?: LayoutHeaderContextSubMenuItem[];
}

@Injectable({ providedIn: 'root' })
export class LayoutHeaderToolbarService {
    private readonly _actions$ = new BehaviorSubject<LayoutHeaderToolbarAction[]>([]);
    private readonly _contextMenu$ = new BehaviorSubject<LayoutHeaderContextMenuItem[]>([]);

    readonly actions$ = this._actions$.asObservable();
    readonly contextMenu$ = this._contextMenu$.asObservable();

    setActions(actions: LayoutHeaderToolbarAction[]): void {
        this._actions$.next(actions);
    }

    setContextMenu(items: LayoutHeaderContextMenuItem[]): void {
        this._contextMenu$.next(items);
    }

    clearContextMenu(): void {
        this._contextMenu$.next([]);
    }

    clear(): void {
        this._actions$.next([]);
        this._contextMenu$.next([]);
    }
}
